import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { isWidthUp } from '@material-ui/core/withWidth';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import reactHtmlParser from 'react-html-parser';

import Card from '../../Card';
import TextField from '../../TextField';
import { generateInputParamsAttributesPdf } from '../../InputParameters/constants';
import FormChip from '../../Chips/FormChip';

const Output = ({ screenWidth, ...props }) => {
	const { t } = useTranslation();
	const { values, touched, errors, handleChange, handleBlur } = props.formikProps;
	return (
		<Card title={t('components.inputs.output.title')} fullHeight>
			<Grid container direction="column">
				<Grid item container direction="row" spacing={3}>
					<Grid item container>
						<FormChip
							title={t('components.inputs.output.isolation')}
							label={<Typography variant="body2">{t('components.inputs.output.isolated')}</Typography>}
							valueName={'isolated'}
							value={values.isolated}
							handleChange={handleChange}
						/>
					</Grid>
					<Grid item xs={isWidthUp('md', screenWidth) ? 6 : 12}>
						<TextField
							id="Output__vout_text_field"
							label={reactHtmlParser(
								generateInputParamsAttributesPdf('').find(item => item.value === 'vout').formattedLabel
							)}
							name="vout"
							InputProps={{
								endAdornment: <InputAdornment position="end">V</InputAdornment>
							}}
							maxLength={7}
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.vout}
							helperText={errors.vout ? errors.vout : '\u00a0'}
							error={errors.vout}
						/>
					</Grid>

					<Grid item xs={isWidthUp('md', screenWidth) ? 6 : 12}>
						<TextField
							id="Output__iout_text_field"
							label={reactHtmlParser(
								generateInputParamsAttributesPdf('').find(item => item.value === 'iout').formattedLabel
							)}
							name="iout"
							InputProps={{
								endAdornment: <InputAdornment position="end">A</InputAdornment>
							}}
							maxLength={7}
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.iout}
							helperText={touched.iout && errors.iout ? errors.iout : '\u00a0'}
							error={touched.iout && errors.iout}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Card>
	);
};

Output.propTypes = {
	screenWidth: PropTypes.number.isRequired
};

export default Output;
